import { SEVERITY_COLOR, hasReportProblems } from './notificationIcons';

const SEVERITY_STYLE = {
    Critical: { main: SEVERITY_COLOR.Critical, light: '#ffeeee', pulse: true },
    Warning:  { main: SEVERITY_COLOR.Warning,  light: '#fff8e1', pulse: false },
    Info:     { main: SEVERITY_COLOR.Info,     light: '#e3f2fd', pulse: false },
};

// Problem-free reports are informational by nature and use the neutral blue
// palette. Reports containing problem entries use the same severity palette as
// alarms and problems.
const REPORT_STYLE = { main: '#007bc1', light: '#e3f2fd', pulse: false };

export function getNotificationStyle(notification) {
    const { notificationType, severity, state } = notification;
    const isActive  = state === 'active' || state === 'Active';
    const isAlarm   = notificationType === 'alarm';
    const isProblem = notificationType === 'problem';
    const isReport  = notificationType === 'report';
    const isReportWithProblems = isReport && hasReportProblems(notification.description);

    const sev = isReport && !isReportWithProblems
        ? REPORT_STYLE
        : (SEVERITY_STYLE[severity] ?? SEVERITY_STYLE.Info);
    const showAccent  = isActive && (isAlarm || isProblem);
    const isResolvedIncident = !isActive && (isAlarm || isProblem);
    // Resolved alarms/problems mirror the detail page banner styling:
    // tinted "success" background + severity-colored accent (icon / left border)
    // + slightly emphasized title — instead of the previous muted grey look.
    // Problem-free reports use the neutral blue REPORT_STYLE for tint + accent.
    const tintBg      = isReport ? sev.light
                       : showAccent ? sev.light
                       : isResolvedIncident ? 'success.light'
                       : 'transparent';
    const iconColor   = isReport ? sev.main
                       : showAccent ? sev.main
                       : isResolvedIncident ? sev.main
                       : '#9e9e9e';
    const titleWeight = isReport ? 600
                       : showAccent ? 600
                       : isResolvedIncident ? 600
                       : 400;
    const pulse       = isActive && sev.pulse && isAlarm;

    const statusLabel = isReport  ? 'REPORT'
                      : isActive  ? 'ACTIVE'
                      : 'RESOLVED';

    const statusColor = isReport  ? (isReportWithProblems ? sev.main : '#007bc1')
                      : isActive  ? sev.main
                      : '#39b620';

    return { sev, showAccent, tintBg, iconColor, titleWeight, pulse, statusLabel, statusColor };
}
